import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EWALLET_MERCHANT_ID } from 'src/app/constant';

@Component({
  selector: 'app-payment-method-selection-dialog',
  templateUrl: './payment-method-selection-dialog.component.html',
  styleUrls: ['./payment-method-selection-dialog.component.scss']
})
export class PaymentMethodSelectionDialogComponent implements OnInit {
  
  allowedMethods: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<PaymentMethodSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.allowedMethods = data.allowedMethods || [];
  }

  ngOnInit(): void {
  }

  selectPaymentMethod(paymentMethod: any) {
    this.dialogRef.close(paymentMethod);
  }

  addNewPaymentMethod() {
    // Close this dialog and signal that we want to add a new payment method
    this.dialogRef.close({ action: 'addNew' });
  }

  cancel() {
    this.dialogRef.close();
  }

  getPaymentMethodDisplayName(payment: any): string {
    if (payment.MerchantId === 5) {
      return payment.CardType || 'Credit Card';
    } else if (payment.MerchantId === EWALLET_MERCHANT_ID || payment.CardType === 'E-Wallet') {
      return 'E-Wallet';
    } else {
      return payment.CardType || payment.DisplayName || payment.Name || 'Payment Method';
    }
  }

  getPaymentMethodIcon(payment: any): string {
    if (payment.MerchantId === EWALLET_MERCHANT_ID || payment.CardType === 'E-Wallet') {
      return 'account_balance_wallet';
    } else {
      return 'credit_card';
    }
  }

  // Format expiration date correctly using UTC to avoid timezone issues
  formatExpirationDate(expires: any): string {
    if (!expires) return '';
    
    try {
      const date = new Date(expires);
      if (!isNaN(date.getTime())) {
        // Use UTC methods to avoid timezone conversion issues
        const month = date.getUTCMonth() + 1;
        const year = date.getUTCFullYear();
        return `${month.toString().padStart(2, '0')}/${year}`;
      }
    } catch (error) {
      console.error('Error formatting expiration date:', error);
    }
    
    return '';
  }
}
